import { render, staticRenderFns } from "./SchoolSearch.vue?vue&type=template&id=45db073e&"
import script from "./SchoolSearch.vue?vue&type=script&lang=ts&"
export * from "./SchoolSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolSearch.vue?vue&type=style&index=0&id=45db073e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports